import { buildClasses } from "../utils/buildClasses";

/**
 * - `block`: a box sized by `className`, e.g. a button or chart.
 * - `text`: a full-width line the height of the surrounding text; narrow it
 *   with a width class.
 * - `circle`: a round box sized by `className`, e.g. an icon or logo.
 */
export type RyeSkeletonShape = "block" | "text" | "circle";

export function RyeSkeleton({
  className = "",
  shape = "block",
}: {
  className?: string;
  shape?: RyeSkeletonShape;
}) {
  return (
    <span
      aria-hidden="true"
      className={buildClasses(
        "bg-on-surface-100",
        "animate-pulse",
        "motion-reduce:animate-none",
        {
          if: shape === "text",
          // As a block it already spans the width, so a width class narrows it.
          then: buildClasses("block", "h-[0.8em]", "my-[0.35em]", "rounded"),
        },
        {
          if: shape === "block",
          then: buildClasses("inline-block", "rounded"),
        },
        {
          if: shape === "circle",
          then: buildClasses("inline-block", "rounded-full"),
        },
        className,
      )}
    />
  );
}

/** A stack of row-shaped placeholders, for lists that are still loading. */
export function RyeSkeletonList({
  rows = 4,
  rowClassName = "h-10",
}: {
  rows?: number;
  rowClassName?: string;
}) {
  return (
    <div className={buildClasses("flex", "flex-col", "gap-2")}>
      {Array.from({ length: rows }, (_, i) => (
        <RyeSkeleton key={i} className={buildClasses("w-full", rowClassName)} />
      ))}
    </div>
  );
}
